import ResidentialCleaning from "pages/CleaningPage/services/Residential";
import OfficeCleaning from "pages/CleaningPage/services/Office";
import AccommodationCleaning from "pages/CleaningPage/services/Accommodation";
import CommercialCleaning from "pages/CleaningPage/services/Commercial";
import SchoolCleaning from "pages/CleaningPage/services/School";
import HealthcareCleaning from "pages/CleaningPage/services/Healthcare";
import EndOfTenancyCleaning from "pages/CleaningPage/services/EndOfTenancy";
import PostConstructionCleaning from "pages/CleaningPage/services/PostConstruction";
import OneOffCleaning from "pages/CleaningPage/services/OneOff";
import DeepCleaning from "pages/CleaningPage/services/DeepCleaning";
import CarpetUpholsteryCleaning from "pages/CleaningPage/services/CarpetUpholstery";

import Careers from "pages/shared/Careers";

import sharedRoutes from "routes/shared";

const [companyRoute, helpRoute] = sharedRoutes;

const cleaningRoutes = [
  companyRoute,
  {
    name: "Services",
    icon: "cleaning_services",
    columns: 1,
    rowsPerColumn: 2,
    collapse: [
      {
        name: "Scheduled Cleaning",
        description: "Scheduled & Recurring",
        collapse: [
          {
            name: "Residential Cleaning",
            description:
              "We provide scheduled home cleaning services tailored to your routine — covering all areas thoroughly so your home is consistently clean and well-maintained.",
            route: "/cleaning/residential/",
            component: <ResidentialCleaning />,
          },
          {
            name: "Office & Workplace Cleaning",
            description:
              "We keep offices and workplaces clean, hygienic, and presentable with flexible scheduling — from daily maintenance to periodic deep cleans suited to your business hours.",
            route: "/cleaning/office/",
            component: <OfficeCleaning />,
          },
          {
            name: "Accommodation Cleaning",
            description:
              "We provide reliable turnaround cleaning for hotels, Airbnbs, and holiday homes — ensuring each guest arrives to a well-presented and thoroughly cleaned space.",
            route: "/cleaning/accommodation/",
            component: <AccommodationCleaning />,
          },
          {
            name: "Commercial Cleaning",
            description:
              "We deliver professional cleaning for retail, hospitality, and commercial premises — keeping your space hygienic and presentable for staff and customers.",
            route: "/cleaning/commercial/",
            component: <CommercialCleaning />,
          },
          {
            name: "School & Educational Facility Cleaning",
            description:
              "We maintain safe, hygienic environments in schools and educational facilities — with vetted, Garda-checked staff and flexible term-time scheduling.",
            route: "/cleaning/school/",
            component: <SchoolCleaning />,
          },
          {
            name: "Healthcare & Medical Facility Cleaning",
            description:
              "We provide specialist cleaning for clinics, GP surgeries, and care homes — following strict infection control protocols to protect patients, residents, and staff.",
            route: "/cleaning/healthcare/",
            component: <HealthcareCleaning />,
          },
        ],
      },
      {
        name: "Specialist Cleaning",
        description: "Situation-Specific Cleans",
        collapse: [
          {
            name: "End of Tenancy Cleaning",
            description:
              "We carry out thorough end of tenancy cleans to bring properties back to a lettable standard — covering all rooms, fixtures, and appliances in line with inspection requirements.",
            route: "/cleaning/tenancy/",
            component: <EndOfTenancyCleaning />,
          },
          {
            name: "Post-Construction Cleaning",
            description:
              "We remove construction dust, debris, and residue to prepare newly built or renovated spaces for handover, ensuring they are clean and ready for use.",
            route: "/cleaning/construction/",
            component: <PostConstructionCleaning />,
          },
          {
            name: "Deep Cleaning",
            description:
              "We carry out intensive top-to-bottom cleans targeting built-up grime, hard-to-reach areas, and surfaces that routine cleaning does not cover.",
            route: "/cleaning/deep-cleaning/",
            component: <DeepCleaning />,
          },
          {
            name: "Carpet & Upholstery Cleaning",
            description:
              "We use specialist equipment to deep clean carpets, rugs, and upholstered furniture — removing dirt, stains, and allergens embedded in fibres.",
            route: "/cleaning/carpet-upholstery/",
            component: <CarpetUpholsteryCleaning />,
          },
        ],
      },
      {
        name: "One-Off Cleaning",
        description: "Any Property, Any Situation",
        collapse: [
          {
            name: "One-Off Cleaning",
            description:
              "We offer flexible one-off cleaning for any property type and any situation — whether following an event, ahead of a move, or simply when a thorough clean is needed.",
            route: "/cleaning/one-off/",
            component: <OneOffCleaning />,
          },
        ],
      },
    ],
  },
  {
    name: "Careers",
    icon: "person_apron",
    route: "/cleaning/careers/",
    component: <Careers />,
  },
  helpRoute,
];

export default cleaningRoutes;
